module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sugarControl"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.showLogin) ? _c('div', {
    staticClass: "container"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-row', {
    staticClass: "padbot",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "saoText",
    staticStyle: {
      "padding-right": "32px"
    },
    attrs: {
      "span": 11.5
    }
  }, [_c('span', {
    class: [!_vm.showQrCode ? 'nowSelect' : ''],
    on: {
      "click": function($event) {
        _vm.select(0)
      }
    }
  }, [_vm._v("扫码登录")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "padding-right": "32px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "saoText",
    attrs: {
      "span": 11.5
    }
  }, [_c('span', {
    class: [_vm.showQrCode ? 'nowSelect' : ''],
    on: {
      "click": function($event) {
        _vm.select(1)
      }
    }
  }, [_vm._v("密码登录")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showQrCode),
      expression: "!showQrCode"
    }]
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('iframe', {
    staticStyle: {
      "height": "250px",
      "width": "250px"
    },
    attrs: {
      "src": _vm.srcUrl,
      "id": "qr-code",
      "title": "请使用APP扫码"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "openTtq"
  }, [_c('span', {
    staticClass: "openTtqText"
  }, [_vm._v("打开糖糖圈app扫描二维码，上传瞬感txt文件")]), _vm._v(" "), _c('span', {
    staticClass: "openA"
  }, [_c('a', {
    staticStyle: {
      "color": "#10c7dc"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.tiaozhuan()
      }
    }
  }, [_vm._v("不知道如何从瞬感扫描仪导出文件？")])])])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hide-success-btn",
      "type": "primary"
    },
    on: {
      "click": _vm.scanlogin
    }
  }, [_vm._v("扫码登录成功")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQrCode),
      expression: "showQrCode"
    }]
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "userP"
  }, [_c('i', {
    staticClass: "userTu"
  }), _vm._v(" "), _c('input', {
    ref: "account",
    staticClass: "user",
    staticStyle: {
      "-webkit-user-select": "auto"
    },
    attrs: {
      "placeholder": "请输入手机号",
      "type": "text"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "keyP"
  }, [_c('i', {
    staticClass: "keyTu"
  }), _vm._v(" "), _c('input', {
    ref: "password",
    staticClass: "key",
    staticStyle: {
      "-webkit-user-select": "auto"
    },
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    }
  })])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "textCenter"
  }, [_c('el-button', {
    attrs: {
      "id": "dl1",
      "type": "primary"
    },
    on: {
      "click": _vm.dlFunction
    }
  }, [_vm._v("登录")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "inputText"
  }, [_c('span', {
    staticClass: "openTtqText"
  }, [_vm._v("登录糖糖圈，上传瞬感txt文件")]), _vm._v(" "), _c('span', {
    staticClass: "openA"
  }, [_c('a', {
    staticStyle: {
      "color": "#10c7dc"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.tiaozhuan()
      }
    }
  }, [_vm._v("不知道如何从瞬感扫描仪导出文件？")])])])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.showLogin) ? _c('div', {
    staticClass: "container pT155"
  }, [_c('el-row', {
    staticClass: "pb20",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "selectBox",
    attrs: {
      "span": 7
    }
  }, [_c('i', {
    staticClass: "tu4 selectBox_i",
    on: {
      "click": _vm.tbText
    }
  }), _vm._v(" "), _c('input', {
    ref: "avatarInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "avatar"
    },
    on: {
      "change": function($event) {
        _vm.changeImage($event)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "selectBox_p"
  }, [_vm._v("选择瞬感TXT文件，"), _c('span', {
    staticClass: "selectBox_p_a"
  }, [_vm._v("继续上传")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('p', {
    staticClass: "hello"
  }, [_vm._v(_vm._s(_vm.nickName) + ",您好")]), _vm._v(" "), _c('p', {
    staticClass: "upTextSize"
  }, [_vm._v("您已成功上传"), _c('span', {
    staticClass: "upTextSize_span"
  }, [_vm._v(_vm._s(_vm.frequency))]), _vm._v("次")]), _vm._v(" "), _c('p', {
    staticClass: "upDate"
  }, [_vm._v("最近一次成功上传日期：" + _vm._s(_vm.time))]), _vm._v(" "), _c('p', {
    staticClass: "findLine"
  }, [_vm._v("您可在糖糖圈APP血糖日历中查看动态曲线")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "padTop",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('span', {
    staticClass: "findText"
  }, [_c('a', {
    staticStyle: {
      "color": "#10c7dc"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.tiaozhuan()
      }
    }
  }, [_vm._v("不知道如何从瞬感扫描仪导出文件?")])])])], 1) : _vm._e(), _vm._v(" "), _c('footerBottomer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "title1"
  }, [_vm._v("瞬感数据同步到糖糖圈APP")]), _vm._v(" "), _c('p', {
    staticClass: "title1Text"
  }, [_vm._v("医生可以通过手机直观的看到您的动态数据 ，进行准确的糖尿病病症分析治疗(糖糖圈APP3.7以上版本)")]), _vm._v(" "), _c('p', {
    staticClass: "sugarTu1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae54dee8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/sugarControl.vue
// module id = 193
// module chunks = 1